export default function KpiWidget({ value }: { value: number | null | undefined }) {
  const formatted =
    value === null || value === undefined
      ? "—"
      : new Intl.NumberFormat("es", { maximumFractionDigits: 1 }).format(value);

  return (
    <div className="flex h-full items-center">
      <div className="text-[38px] font-bold tracking-tight text-foreground/90">
        {formatted}
      </div>
    </div>
  );
}
